module.exports = __webpack_public_path__ + "img/kkb_beam10r.89a65247.jpg";